import Vue from 'vue'
import VueRouter from 'vue-router'
import InsuranceProjectManagement from '@/views/InsuranceProjectManagement.vue'
import TestDriveStatistics from '@/views/TestDriveStatistics.vue'
import RouteManagement from '@/views/RouteManagement.vue'
import Development from '@/views/Development.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/workbench',
    name: 'Workbench',
    component: Development,
    meta: {
      title: '工作台',
      parent: null,
      parentPath: null
    }
  },
  {
    path: '/',
    redirect: '/workbench'
  },
  {
    path: '/insurance-project-management',
    name: 'InsuranceProjectManagement',
    component: InsuranceProjectManagement,
    meta: {
      title: '保险项目管理',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/pre-declaration',
    name: 'PreDeclaration',
    component: Development,
    meta: {
      title: '预申报',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-correction',
    name: 'InsuranceCorrection',
    component: Development,
    meta: {
      title: '保险批改',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-roster',
    name: 'InsuranceRoster',
    component: Development,
    meta: {
      title: '投保名册',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/group-insurance',
    name: 'GroupInsurance',
    component: Development,
    meta: {
      title: '团险保单管理',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-application',
    name: 'InsuranceApplication',
    component: Development,
    meta: {
      title: '投保申请单',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-plan',
    name: 'InsurancePlan',
    component: Development,
    meta: {
      title: '投保方案',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/commercial-package',
    name: 'CommercialPackage',
    component: Development,
    meta: {
      title: '商险产品套餐',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-company-plan',
    name: 'InsuranceCompanyPlan',
    component: Development,
    meta: {
      title: '保险公司方案',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/daily-insurance',
    name: 'DailyInsurance',
    component: Development,
    meta: {
      title: '日保单',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/cargo-insurance-project',
    name: 'CargoInsuranceProject',
    component: Development,
    meta: {
      title: '货运险项目',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/cargo-insurance',
    name: 'CargoInsurance',
    component: Development,
    meta: {
      title: '货运险',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-bill',
    name: 'InsuranceBill',
    component: Development,
    meta: {
      title: '保险账单',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-company',
    name: 'InsuranceCompany',
    component: Development,
    meta: {
      title: '保司管理',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/sales-reconciliation',
    name: 'SalesReconciliation',
    component: Development,
    meta: {
      title: '销售对账单',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/insurance-claim',
    name: 'InsuranceClaim',
    component: Development,
    meta: {
      title: '保险报案',
      parent: '商业保险',
      parentPath: '/pre-declaration'
    }
  },
  {
    path: '/test-drive-statistics',
    name: 'TestDriveStatistics',
    component: TestDriveStatistics,
    meta: {
      title: '车辆管理',
      parent: '试车数据统计管理',
      parentPath: '/test-drive-statistics'
    }
  },
  {
    path: '/route-management',
    name: 'RouteManagement',
    component: RouteManagement,
    meta: {
      title: '线路管理',
      parent: '试车数据统计管理',
      parentPath: '/test-drive-statistics'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
